@use '../@shared/global' as *;
@use '../@shared/card.mixin' as *;
@use '../@shared/mixins' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	@include kol-card;

	.kol-drawer {
		$root: &;

		&__dialog {
			padding: 0;
			border: none;
		}

		&__wrapper {
			position: fixed;
			overflow: auto;

			&--left,
			&--right {
				top: 0;
				max-width: 100vw;
				height: 100vh;

				#{$root}__content {
					height: 100%;
				}
			}

			&--left {
				left: 0;
			}

			&--right {
				right: 0;
			}

			&--bottom,
			&--top {
				left: 0;
				width: 100vw;
				max-height: 100vh;

				#{$root}__content {
					width: 100%;
				}
			}

			&--bottom {
				bottom: 0;
			}

			&--top {
				top: 0;
			}
		}

		&__content {
			position: relative;
		}
	}

	.kol-drawer__dialog .kol-card__content {
		overflow-y: auto;
	}
}
